import PluginDecorator from './PluginDecorator';
import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";
import mergeOptions from "../../utils/wrappers/merge-options";

// load plugin
import "videojs-persistvolume";
import Constants from "../../utils/Constants";

export default class PersistVolumePluginDecorator extends PluginDecorator{

    static readonly PLUGIN_NAME = 'persistvolume';

    static bootingStaticApi() {
        super.bootingStaticApi();
        this.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl: Element, options: any) => {
            return this.processOptions(options);
        });
    }

    static processOptions(options: any) {
        
        options.plugins.persistvolume = options.plugins.persistvolume || {};

        // extend default configuration with custom configuration
        options.plugins.persistvolume = mergeOptions({},{
            namespace: Constants.NAMESPACE_LOCALSTORAGE_COOKIE
        },options.plugins.persistvolume);

        return options;
    }

}


// WEBPACK FOOTER //
// ./src/app/plugins/decorators/PersistvolumePluginDecorator.ts